/**
 * Resolve the game-server report id for the current user (no duplicate inserts).
 * Checks session first, then stages.reportid via backend.
 */
export async function fetchExistingReportId({ sessionId, organizationId, userId }) {
  const sid = sessionId != null ? String(sessionId).trim() : "";
  const oid = organizationId != null ? String(organizationId).trim() : "";
  const uid = userId != null ? String(userId).trim() : "";
  if (!sid || !oid || !uid) return null;

  try {
    const backendBase = String(process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
    if (!backendBase) return null;

    const res = await fetch(`${backendBase}/fetchReport`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sid}&${oid}`,
      },
      body: JSON.stringify({ userId: uid, sessionId: sid, organizationId: oid }),
    });
    const data = await res.json().catch(() => ({}));
    if (!data?.success || !data.report) return null;

    const rid = data.report.reportid ?? data.report.reportId ?? null;
    if (rid != null && String(rid).trim() !== "") return String(rid).trim();
  } catch {
    /* ignore */
  }
  return null;
}

/** reportId from userData / gameSettings (never stages row id). */
export function readReportIdFromSession(user = {}) {
  const fromUser = user.reportId ?? user.reportid ?? user.reportID;
  if (fromUser != null && String(fromUser).trim() !== "") return String(fromUser).trim();

  try {
    const gs = JSON.parse(sessionStorage.getItem("gameSettings") || "{}") || {};
    const fromGs = gs.reportId ?? gs.reportid ?? gs.reportID;
    if (fromGs != null && String(fromGs).trim() !== "") return String(fromGs).trim();
  } catch {
    /* ignore */
  }
  return null;
}
